export default __webpack_public_path__ + "static/4-3-marketing-b44bed860340179a5f32f8d085600e32.gif";